export default "__VITE_ASSET__2b9253d3__"